import React from 'react';
import Icon from '../../../../Component/Layouts/App/Candidates/StudentApp/Icon';
import { GradientMark, PageHeader, SectionTitle } from '../../../../Component/Layouts/App/Candidates/StudentApp/StudentUi';
import { useStudent } from '../../../../Component/Layouts/App/Candidates/StudentApp/StudentContext';
import { STUDENT_BASE, feed, picks } from '../../../../Component/Layouts/App/Candidates/StudentApp/studentData';

const ActivityFeed = () => {
  const { liked, toggleLike, showToast } = useStudent();

  return (
    <>
      <PageHeader
        title="For You"
        backTo={STUDENT_BASE}
        right={<button type="button" className="sa-ib" aria-label="Filter"><Icon name="filter" /></button>}
      />
      <SectionTitle title="Picked for you" />
      {picks.map((pick) => (
        <div className="sa-card sa-item" key={pick.title}>
          <GradientMark name={pick.icon} from={pick.from} to={pick.to} />
          <div className="sa-sp">
            <div className="sa-b" style={{ fontSize: 14 }}>{pick.title}</div>
            <div className="sa-mut">{pick.reason}</div>
            <button type="button" className="sa-btn soft" style={{ marginTop: 6, padding: '6px 12px' }} onClick={() => showToast(pick.action)}>
              {pick.action}
            </button>
          </div>
          <Icon name="next" />
        </div>
      ))}

      <SectionTitle title="What's happening on Focalyt?" />
      {feed.map((item, index) => (
        <div className="sa-card sa-row" key={item.name} style={{ marginBottom: 10 }}>
          <div className="sa-av" style={{ background: 'linear-gradient(135deg,#6366f1,#06b6d4)' }}>{item.name[0]}</div>
          <div className="sa-sp">
            <div style={{ fontSize: 13 }}><b>{item.name}</b> {item.text}</div>
            <div className="sa-mut">{item.time}</div>
            <div className="sa-row" style={{ gap: 14, marginTop: 4 }}>
              <button type="button" className={`sa-like${liked[index] ? ' on' : ''}`} onClick={() => toggleLike(index)}>
                <Icon name="heart" />
                {item.likes + (liked[index] ? 1 : 0)}
              </button>
              <span className="sa-like"><Icon name="msg" />{item.comments}</span>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ActivityFeed;
